import { Component, TemplateRef, contentChild, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-autocomplete',
  templateUrl: './primeng-autocomplete.component.html',
  styleUrls: ['./primeng-autocomplete.component.scss'],
  standalone: false,
})
export class PrimengAutoCompleteComponent {
  value = model<any>(null);
  suggestions = input<any[]>([]);
  field = input<string>('');
  placeholder = input<string>('');
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  multiple = input<boolean>(false);
  dropdown = input<boolean>(false);
  forceSelection = input<boolean>(false);
  minLength = input<number>(1);
  delay = input<number>(300);
  appendTo = input<string>('body');
  emptyMessage = input<string>('No results found');
  styleClass = input<string>('');
  fluid = input<boolean>(false);
  id = input<string>('');
  label = input<string>('');

  completeMethod = output<any>();
  onSelect = output<any>();
  onUnselect = output<any>();
  onClear = output<void>();

  /** Custom suggestion item template: <ng-template #acItem let-item>...</ng-template> */
  itemTemplate = contentChild<TemplateRef<any>>('acItem');
  /** Custom selected item template (for multiple mode): <ng-template #acSelected let-item>...</ng-template> */
  selectedItemTemplate = contentChild<TemplateRef<any>>('acSelected');

  handleCompleteMethod(event: any) {
    this.completeMethod.emit(event);
  }

  handleSelect(event: any) {
    this.onSelect.emit(event);
  }

  handleUnselect(event: any) {
    this.onUnselect.emit(event);
  }

  handleClear() {
    this.value.set(null);
    this.onClear.emit();
  }
}
